import styled from 'styled-components';

import { StarBall } from '#src/atoms/icons/StarBall/index.tsx';

export const SmallerStarBall = styled(StarBall)`
  width: 28px;
`;
